<template>
  <div v-if="isMarketplaceEnabled">
    <h5 class="title m-0">Marketplace</h5>
    <div class="d-flex">
      <div>
        <div :class="subscriptionBadgeClass">
          <h2>{{ billing_account.balance }}</h2>
          <!-- <h2 v-if="!billing_account.infinite">{{ billing_account.balance }}</h2>
            <h2 v-if="billing_account.infinite">
              <img src="/icons/infinity.svg" class="infinity" />
          </h2>-->
          <h3>UAH</h3>
        </div>
        <button
          class="default-btn subscription-btn"
          @click="deposit_modal = true"
        >{{ $t('general.balance.marketadd') }}</button>
      </div>

      <div class="ml-auto">
        <div class="flags">
          <div class="flag">
            <span class="mode preorder">TAKEAWAY</span>
            <span class="commission">{{ billing_account.comission.preorder || 3}}%</span>
          </div>
          <div class="flag">
            <span class="mode delivery">DELIVERY</span>
            <span class="commission">{{ billing_account.comission.delivery || 3}}%</span>
          </div>
          <div class="flag">
            <span class="mode reserve">RESERVE</span>
            <span class="commission fix-price">{{ billing_account.comission.reserve || 5}} UAH</span>
          </div>
        </div>

       <button class="default-btn mt-15" @click="$router.push('/marketplace')">
        {{ $t('general.cafe.settings' )}}
        </button>

        <button
          class="default-btn history-btn"
          @click="showBills()"
          v-if="isCompact"
        >{{ $t('general.cafe.settings') }}</button>
      </div>
      <!-- <div class="d-flex justify-content-center">
            <img src="/icons/visa-card.svg" class="take2pay" />
            <img src="/icons/ms-card.svg" class="take2pay" />
      </div>-->
    </div>

    <!-- <div class="buy-history">
      <div
        :class="{
          item: true,
          filled: item.amount > 0
        }"
        v-for="item in last_transactions"
        :key="item._id"
      >{{ item.amount > 0 ? '+': ''}} {{ item.amount }} UAH {{ -item.comission}}% - {{ item.total }} UAH - {{ item.created_at | formatDatetime }}</div>
    </div> -->

    <DepositModal v-if="deposit_modal" @close="deposit_modal = false" />
  </div>
</template>

<script>
import DepositModal from "@/components/billing/DepositModal.vue"

export default {
  data() {
    return {
      deposit_modal: false,
      amount: 300,
      last_transactions: []
    };
  },
  components: {
    DepositModal
  },
  methods: {
    showBills() {
      this.$router.push("/marketplace");
    }
  },
  computed: {
    subscriptionBadgeClass() {
      return {
        "subscription-badge": true,
        "subscription-badge-notactive": this.billing_account.balance < 0
      };
    },
    billing_account() {
      return this.$store.state.billing_account;
    },
    isMarketplaceEnabled() {
      return this.$store.state.marketplace_enabled;
    }
  },
  props: {
    isCompact: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
h2 {
  font-size: 4.5vh;
  padding: 0;
  display: block;
  min-width: 16vh;
}

h3 {
  font-size: 2.5vh;
}

h5.title {
  margin-bottom: 1.7vh !important;
  font-size: 2vh;
  color: #ededed;
}

span.commission {
  background: #464646;
  padding: 0.4vh 2vh 0.4vh 3vh;
  display: inline;
  text-align: center;
  z-index: 0;
  color: #ededed;
  width: 15vh;
  margin-left: -1vh;
  border-radius: 0 0.8vh 0.8vh 0;
  font-size: 1.7vh;
}

.default-btn:hover {
  background: #129b81;
  border:1px solid transparent;
}

.commission.fix-price {
  padding: 0.4vh 0 0.4vh 1.8vh;
}

.inside {
  background: #262626 !important;
  color: #ededed;
}
.preorder {
  background: #ffd2a8 !important;
  color: #1d1d1b !important;
}
.delivery {
  background: #cbd9e6 !important;
  color: #1d1d1b !important;
}
.reserve {
  background: #aeccc6 !important;
  color: #1d1d1b !important;
}

.buy-history {
  max-height: 7vh;
  margin-top: 3vh;
  overflow: auto;
  background: linear-gradient(
    180deg,
    rgba(29, 29, 27, 0) 39.58%,
    #1d1d1b 92.19%
  );
}

.buy-history .item {
  font-size: 1.5vh;
  padding-top: 0.5vh;
  color: #ededed;
  line-height: normal;
}

.buy-history .item.filled {
  color: #129b81;
}

small.status-flag {
  color: #908f8d;
  line-height: normal;
  display: block;
  font-size: 1.5vh;
  padding-top: 1vh;
}

small.status-flag.active {
  color: #129b81;
}

small.status-flag.end {
  color: #e2223b;
}

.flag {
  display: flex;
  margin-top: 1.22vh;
  position: relative;
  
}

.flag:first-child {
  margin: 0;
}

.flag .mode {
  color: #ededed;
  text-align: center;
  position: relative;
  font-weight: bold;
  z-index: 2;
  width: 14vh;
  display: inline-block;
  border-radius: 0.8vh;
  font-size: 1.7vh;
  background: #262626;
  padding: 0.5vh 0 0.5vh;
}

.flag-disabled {
  color: #a4a3a1;
}

.subscription-active {
  margin-bottom: 1.1vh;
  font-size: 2vh;
}

.subscription-badge {
  border: 2px solid #129b81;
  color: #129b81;
  padding: 2vh 0.5vh 0;
  align-self: center;

  height: 13vh;
  border-radius: 1.3vh;
  text-align: center;
  width: fit-content;
  display: block;
  width: 20vh;
}

.subscription-badge-notactive {
  border: 2px solid #e2223b;
  color: #e2223b;
}

.subscription-btn,
.history-btn {
  background: #129b81;
  color: white;
  border:1px solid transparent;
  margin-top: 1.7vh;
   
}

.history-btn {
  background: transparent;
  color: #908f8d;
  padding: 0.4vh 0 0.5vh;
  border: 1px solid #908f8d;
}

.marketplace-prices-box {
  display: block;
  margin: -3.3vh 0 -3.3vh auto;

  padding: 3.3vh 0 3.3vh 3.3vh;
  border-left: 1px solid #464646;
  width: 45vh;
}

.general-wrapper {
  display: flex;
  padding-top: 2.2vh;
  justify-content: space-between;
  width: 100%;
}

.pl-25 {
  padding-left: 2.8vh;
  display: grid;
}

p {
  margin-bottom: 0;
}

.subscription-tarrifs {
  margin-top: 1.2vh;
  display: block;
}

.choose-period img {
  height: 2vh;
  width: auto;
  display: block;
  margin: 2vh auto 0;
}

.period-box input {
  width: 100%;
  background: transparent;
  color: #ededed;
  outline: none;
  padding: 1.8vh 2vh;
  border: none;
}

.choose-period {
  width: 45vh;
  position: absolute;
  left: 0;
  right: 0;
  padding: 5vh;
  top: 50%;
  transform: translateY(-50%);
  border: 1px solid #464646;
  margin: 0 auto;
  color: #ededed;
}

.choose-period h3 {
  font-size: 2.8vh;
  line-height: 0.8;
  padding: 0 0 2.2vh;
}

.period-box {
  border-radius: 1vh;
  border: 1px solid #1d1d1b;
  padding: 1.8vh 2vh;
  margin-top: 1.1vh;
  font-size: 2vh;
}

.period-box img {
  height: 3vh;
  width: auto;
  align-self: center;
}
.period-box.active {
  background: #1d1d1b;
  border: 2px solid #129b81;
}
header {
  padding: 6vh 0 0 0;
  width: 118vh;
  margin: 0 auto;
  color: #ededed;
}

header h2 {
  padding: 1vh 0 0 0;
  font-size: 4vh;
}

button.pay {
  background: #11d180;
  width: 100%;
  border: none;
  color: #ededed;
  border-radius: 1vh;
  margin-top: 2vh;
  font-size: 2vh;
  padding: 1.3vh 1vh;
  cursor: pointer;
}

button.pay:disabled {
  opacity: 0.7;
}

.payment-block {
  position: absolute;
  bottom: 18vh;
  left: 0;
  right: 0;
  text-align: center;
}

.infinity {
  width: 10vh;
}

.badge-align {
  margin-top: 2.2vh;
}
</style>